import React from 'react'
import { Card } from 'react-bootstrap'
import { CardRowItem } from '../../cardRowItem'
import * as E from './checklistCardElements'
import { nswHNStaticData } from './nswHNStaticData'
import { ITheme } from 'application/utils/type'

import {
  ICardRowItem,
  IDatablock,
  IStaticDataItem,
} from './proposalInterfaces/cardStaticDataTypes'
import { ICardChecklistItemProps } from './proposalInterfaces/cardCheckListItemProps'

const NswHNFormattedData = (theme: ITheme) => {
  const preparePrefixCard = (data: IStaticDataItem, theme: ITheme) => {
    if (!!data.prefix) {
      let foo: JSX.Element = (
        <div>
          {data.prefix && (
            <div
              dangerouslySetInnerHTML={{
                __html: data.prefix as unknown as string,
              }}
            ></div>
          )}
        </div>
      )
      return foo
    }
  }

  const prepareSuffixCard = (data: IStaticDataItem, theme: ITheme) => {
    if (!!data.suffixCard)
      return (
        <div>
          <Card
            style={{
              borderWidth: '0',
              backgroundColor: '#f7f7f7',
            }}
          >
            <Card.Body
              dangerouslySetInnerHTML={{ __html: data.suffixCard.cardBody }}
            ></Card.Body>
            {data.suffixCard.cardRowItems.map((cri) => {
              return (
                <CardRowItem
                  title={
                    <E.PrimaryText theme={theme}>{cri.title}</E.PrimaryText>
                  }
                  value={cri.value}
                  isCurrency={!!cri.isCurrency}
                  longVal={!!cri.longVal}
                  rightTextcss="font-weight-bold"
                />
              )
            })}
          </Card>
        </div>
      )
  }

  let foo: IStaticDataItem[] = nswHNStaticData.map((card: any) => {
    return {
      cardNumber: card.cardNumber,
      cardHeadingNumber: card.cardHeadingNumber,
      title: card.title,
      hideInPdf: card.hideInPdf,
      prefix: preparePrefixCard(card, theme),
      prefixPdf: card.prefixPdf,
      suffix: prepareSuffixCard(card, theme),
      pdfText: card.pdfText,
      datablocks: card.datablocks.map((db: IDatablock) => {
        return {
          heading: db.heading,
          showIds: db.showIds,
          checklistItems: db.checklistItems.map(
            (ci: ICardChecklistItemProps) => {
              return {
                id: ci.id,
                isChecked: ci.isChecked,
                text: ci.text,
              }
            }
          ),
        }
      }),
    }
  })
  return foo
}

export default NswHNFormattedData
